import { GTMService } from './gtm-service';
import { Config } from './config.model';
import { ECData } from './ecdata.model';
import { ECDataPurchase } from './ecdataPurchase.model';
import { Logger } from './log-service';

export class EnhancedEcommerceService {

  gtm: GTMService;
  debug: Logger;
  ecAttrsRequired:any = {
    'id': true,
    'name': true,
    'price': true
  };
  ecAttrsLookup:any = {
    'list': true,
    'category': true,
    'brand': true
  };
  ecAttrsSkip:any = {
    'action': true
  };
  ecAttrsAllowed:any = {
    'id': true,
    'name': true,
    'brand': true,
    'price': true,
    'position': true,
    'category': true,
    'variant': true,
    'list': true,
    'currency': true,
    'url': true
  };
  selectedNodes: NodeListOf<Element>;

  constructor(
    private config: Config
  ) {

    this.gtm = new GTMService(config.dataLayer, this);
    this.debug = new Logger(config.debug);

    if (this.config.prefix === undefined)
    {
      this.config.prefix = 'data-ec';
    }

    if (this.config.currencyCode === undefined)
    {
      this.config.currencyCode = 'EUR';
    }

  }
  
  init() {
    
    this.selectedNodes = document.querySelectorAll("*[" + this.config.prefix + "-action]");

    var impressions: Array<ECData> = [];
    var self = this;

    for (var i = 0; i < this.selectedNodes.length; i++) {
      var node = this.selectedNodes[i];
      var actions = node.getAttribute(this.config.prefix + '-action').split(',');
      actions.map(action => {
        action = action.trim();

        switch(action) {
          case 'view': 
            this.debug.log('run view');
            let ecData:ECData = this.getData(node);
            if (ecData.id) {
              impressions.push(ecData);
            }
            break;
          case 'follow':
            this.debug.log('apply follow');
            node.addEventListener('click', (event) => {
              let ecData:ECData = self.getData(event.srcElement);
              if (ecData.url) {
                event.preventDefault();
              }
              this.gtm.followProduct(ecData);
            });
            break;
          case 'detail':
            this.debug.log('apply detail');
            let ecDataDetail:ECData = this.getData(node);
            this.debug.log(JSON.stringify(ecDataDetail, null, '\t'));
            this.gtm.trackProductDetail(ecDataDetail);
            break;
          case 'purchase':
            this.debug.log('apply purchase');

            let purchaseData = <ECDataPurchase>{};
            let purchaseProducts = JSON.parse(document.querySelector("*[" + this.config.prefix + "-products]").getAttribute(this.config.prefix + '-products'));
        
            let ecId = document.querySelector("*[" + this.config.prefix + "-purchase-id]").getAttribute(this.config.prefix + '-purchase-id');
            let ecAffiliation = document.querySelector("*[" + this.config.prefix + "-purchase-affiliation]").getAttribute(this.config.prefix + '-purchase-affiliation');
            let ecTax = document.querySelector("*[" + this.config.prefix + "-purchase-tax]").getAttribute(this.config.prefix + '-purchase-tax');
            let ecShipping = document.querySelector("*[" + this.config.prefix + "-purchase-shipping]").getAttribute(this.config.prefix + '-purchase-shipping');
            let ecRevenue = document.querySelector("*[" + this.config.prefix + "-purchase-revenue]").getAttribute(this.config.prefix + '-purchase-revenue');
        
            // setup purchase details object
            purchaseData.id = ecId;
            purchaseData.affiliation = ecAffiliation;
            purchaseData.tax = parseFloat(ecTax).toFixed(2);
            purchaseData.shipping = parseFloat(ecShipping).toFixed(2);
            purchaseData.revenue = parseFloat(ecRevenue).toFixed(2);
      
            this.debug.log('apply purchase with actionField:');
            this.debug.log(JSON.stringify(purchaseData, null, '\t'));
            this.debug.log('apply purchase with products:');
            this.debug.log(JSON.stringify(purchaseProducts, null, '\t'));
            this.gtm.purchase(purchaseData, purchaseProducts);
            break;
          case 'step':
            let step = parseInt(document.querySelector("*[" + this.config.prefix + "-step]").getAttribute(this.config.prefix + '-step'));
            let stepProducts = JSON.parse(document.querySelector("*[" + this.config.prefix + "-step]").getAttribute(this.config.prefix + '-products'));
            this.debug.log('apply step ' + step + ' with products:');
            this.debug.log(JSON.stringify(stepProducts, null, '\t'));
            this.gtm.steps(step, '', stepProducts);
            break;
        }

      });
    }

    if (impressions.length)
    {
      this.gtm.trackProductViews(impressions);
    }

    this.debug.warn('initialized on ' + this.selectedNodes.length + ' nodes');

    // track cart step with options (optionally) on click to the next step
    if(document.getElementsByClassName(`${this.config.prefix}-track-cart-step`)[0]) {
      let mainNode: Element;

      document.getElementsByClassName(`${this.config.prefix}-track-cart-step`)[0].addEventListener('click', (e: MouseEvent) => {
        mainNode = <HTMLElement>e.target;
        let optionsArr: any = [];
        let stepProducts = JSON.parse(document.querySelector("*[" + this.config.prefix + "-products]").getAttribute(this.config.prefix + '-products'));

        let step = parseInt(mainNode.getAttribute(this.config.prefix + '-step'));

        this.debug.log('apply step ' + step + ' with products:');
        this.debug.log(JSON.stringify(stepProducts, null, '\t'));
        
        let options = document.querySelectorAll("*[" + this.config.prefix + "-option]");
        if(options) {
          options.forEach(option => {
            let optionChecked = <HTMLInputElement><any>option;
  
            if(optionChecked.checked) {
              optionsArr.push(optionChecked.value);
            }
          });
          if(optionsArr.length) {
            this.debug.log('options: ' + optionsArr.join(' / '));
          }
        }

        this.gtm.steps(step, optionsArr ? optionsArr.join(' / ') : '', stepProducts);
      });
    }

  }


  responseInit(appendLimit: number) {
    // track products view on appended products into DOM
    this.selectedNodes = document.querySelectorAll(`.${this.config.prefix}-item-response[${this.config.prefix}-action]`);

    var impressions: Array<ECData> = [];

    this.selectedNodes.forEach((item, index) => {
      if((index + 1) >= appendLimit) {
        var node = item;
  
        var actions = node.getAttribute(this.config.prefix + '-action').split(',');
        var itemsId = node.getAttribute(this.config.prefix + '-id');
        actions.filter((action, index) => {
          action = action.trim();
          if (action == 'view') {
            this.debug.log('run view on AJAX success - item ID: ' + itemsId);
            let ecData = this.getData(node);
            if (ecData.id) {
              impressions.push(ecData);
            }
          }
        });
      }
    });

    if(impressions) {
      this.gtm.trackProductViews(impressions);
    }
  }
  

  private getData(node: Element)
  {
    let ecData: any = {

    };
    let mainNode: Element;
    /* mainNode is node with closest data-ec-id attribute */
    mainNode = node.closest('*[' + this.config.prefix + '-id]');
    if (!mainNode)
    {
      this.debug.log('cant find closest node with filled product id');
      return ecData;
    }

    /* check all attributes in main node and matched attach to ecData */
    for (var i = 0, n = mainNode.attributes.length; i < n; i++) {

      let nodeName = mainNode.attributes[i].nodeName;
      if (nodeName.match('^' + this.config.prefix))
      {
        nodeName = nodeName.replace(this.config.prefix + '-',"");
        if (this.ecAttrsSkip[nodeName]) {
          continue;
        }
        /* if this attribute is not in allowed list, ignore it */
        if (!this.ecAttrsAllowed[nodeName]) {
          this.debug.log('not supported attr name ' + this.config.prefix + '-' + nodeName);
        }
        /* attach to ecData */
        ecData[nodeName] = mainNode.attributes[i].nodeValue;
      }
    }

    /* search all attributes with missing data in upper nodes */
    Object.keys(this.ecAttrsLookup).forEach((key) => {
      if (!ecData[key]) {
        let attrNode = node.closest('*[' + this.config.prefix + '-' + key + ']')
        if (attrNode)
        {
          ecData[key] = attrNode.getAttribute(this.config.prefix + '-' + key);
        }
      }
    });

    /* check if nothing required missing */
    Object.keys(this.ecAttrsRequired).forEach((key) => {
      if (!ecData[key]) {
        this.debug.warn("can't find not null attr name " + this.config.prefix + '-' + key);
      }
    });

    /* calculate position in list */
    if (ecData['list'] && !ecData['position']) {
      ecData['position'] = 1;
      let sibNode: Element = mainNode;

      if(sibNode.closest(`[${this.config.prefix}-position]`)) {
        ecData['position'] = sibNode.closest(`[${this.config.prefix}-position]`).getAttribute(this.config.prefix + '-position');
      } else {
        while (sibNode = sibNode.previousElementSibling) {
          ecData['position']++;
        }
      }

    }

    return ecData;
  }

  follow(node: Element) {

    this.debug.info('track follow()');
    
    let ecData:ECData = this.getData(node);
    if (ecData.url)
    {
      event.preventDefault();
    }
    this.gtm.followProduct(ecData);

  }

  addCart(node: Element, config: ECData) {
    
    this.debug.info('track addCart()');
    
    let nodeData:ECData = this.getData(node);
    let ecData:ECData = {...nodeData, ...config};

    this.debug.log(JSON.stringify(ecData, null, '\t'));
    this.gtm.addCartProduct(ecData);
  }

  removeCart(node: any, config: any) { /* seem little bit ugly */
    
    this.debug.info('track removeCart()');
    
    let nodeData:ECData;
    let ecData:ECData;

    if (typeof node === "object" && node.nodeType === 1)
    {
      nodeData = this.getData(node);
      ecData = {...nodeData, ...config};
    }
    else
    {
      ecData = node;
    }

    this.debug.log(JSON.stringify(ecData, null, '\t'));
    this.gtm.removeCartProduct(ecData);
  }

  steps(step: number, optionsArr: any = [], stepProducts: Array<ECData>) {
    if(!stepProducts) {
      stepProducts = JSON.parse(document.querySelector("*[" + this.config.prefix + "-step]").getAttribute(this.config.prefix + '-products'));
    }
    if(optionsArr.length) {
      this.debug.log('options: ' + optionsArr.join(' / '));
    }

    this.debug.log('apply step ' + step + ' with products:');
    this.debug.log(JSON.stringify(stepProducts, null, '\t'));
    this.gtm.steps(step, optionsArr ? optionsArr.join(' / ') : '', stepProducts);
  }

  purchase(actionField: ECDataPurchase, products: Array<ECData>) {
    this.debug.log('apply purchase with actionField:');
    this.debug.log(JSON.stringify(actionField, null, '\t'));
    this.debug.log('apply purchase with products:');
    this.debug.log(JSON.stringify(products, null, '\t'));
    this.gtm.purchase(actionField, products);
  }

}